import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { GetAlertsComponent, getConstantTextFields, setObjectByPath, validateConstantValues} from "./utils"
import NumberFormat from 'react-number-format';
import _ from 'lodash'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TimeDeltaTextField from './Components/TimeDeltaTextField'

export function DivisionBox (props) {
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props

    return (
        <div>
            {!read_only ?
                <div style={{display:"flex", alignItems: "center"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t("Divisão")}
                        {(node.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={node.node.alerts} />  : null} 
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(node)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(node)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
                :
                <div style={{display:"flex"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t("Divisão")}
                    </div>
                </div>
            }
        </div>
    )
}

export function DivisionConfiguration(props){
    const { t } = useTranslation();
    let {handleConfigurationClose} = props
    let {read_only} = props
    let { handleNodeChange } = props
    let {node} = props

    const [nodeState, setNodeState] = useState(node)
    let standardTextField = getConstantTextFields("number")
    let getType = node.node.instance.getType
    let type_translate = {"number":"number", "string":"timedelta"}

    useEffect(() => {
        setNodeState(node)
    }, [node])

    const getTypeAssumingNumber = (node) => {
        return (getType(node) !== "timedelta") ? "number" : "timedelta"
    }

    const getCurrentValue = (nodeState) => {
        let node_value_type = getTypeAssumingNumber(nodeState.node)
        let current_value_type = type_translate[typeof nodeState.node.properties.default_value] ?? "number"
        if (node_value_type === current_value_type) 
            return nodeState.node.properties.default_value
        else
            return null 
    }

    const handleNodeStateChange = (obj_key, value) => {
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node, "properties.default_value_type", type_translate[typeof value])
        setObjectByPath(new_node.node, obj_key, value)
        setNodeState(new_node)
    }

    const handleSave = () => {
        handleConfigurationClose()
        handleNodeChange(nodeState)
    }

    return(
        <div style={{flexGrow:"1", padding: "20px", display:"flex", flexDirection:"column"}}>
            <div style={{display: "flex"}}>
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>{t(node.node.description)}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help,index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                    <HelpIcon style={{fontSize: "14px", display:"flex", margin:"auto 5px"}}/>
                </Tooltip>
            </div>
            <p className={["blueText", "subtitleSize", "labelSpace"].join(" ")} style={{fontSize: "14px", margin: "8px 0 -10px 4px", width: "100%", textAlign: "center"}}>{t("Valor a ser usado em caso de divisão por zero")}</p>
            {getTypeAssumingNumber(node.node) !== "timedelta" && 
            <div className="internalCardContainer" style={{display:"flex", flexDirection: "column"}}>
                <NumberFormat
                    style={{textAlign:"center", width:"80%", margin:"3px auto"}}
                    error={!validateConstantValues("number", nodeState.node.properties.default_value)}
                    {...standardTextField.props}
                    label={t("Valor padrão")}
                    value={getCurrentValue(nodeState)}
                    onValueChange={(e) => handleNodeStateChange("properties.default_value", e.floatValue)}
                    InputProps={{
                        readOnly: read_only
                      }}
                />          
            </div>}
            {getTypeAssumingNumber(node.node) === "timedelta" && 
            <TimeDeltaTextField
                value={getCurrentValue(nodeState)}
                error={!validateConstantValues("timedelta", nodeState.node.properties.default_value)}
                valueChangeFunction={(value) => handleNodeStateChange("properties.default_value", value)}
                label={null}
                read_only={read_only}
            />}      
            <div style={{ display: "flex", margin: "auto auto 5px auto" }}>
                <div
                    className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                    style={{ width: "120px" }}
                    onClick={handleConfigurationClose}
                >
                    {read_only ? "X" : t("discard")}
                </div>
                {!read_only &&
                    <div
                        className={
                            validateConstantValues(getTypeAssumingNumber(node.node), nodeState.node.properties.default_value)
                                ?
                                ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                :
                                ["button", "standard", "normalText", "normalMediumSize", "disabled"].join(" ")}
                        style={{ width: "120px" }}
                        onClick={validateConstantValues(getTypeAssumingNumber(node.node), nodeState.node.properties.default_value) ? handleSave : null}
                    >
                        {t("save")}
                    </div>}
            </div>
        </div>
    )
}

export class DivisionBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
    }
    validate(node){
        let put_error = false
        let alerts = []
        //Validate if node has at least one child
        if((node.node.children || []).length !== 2){
            put_error = true
            alerts.push("Este nó precisa ter exatamente dois filhos.")
        }
        else{
            //Validate if all children of the node are Numbers or Timedeltas
            let first_type = node.node.children[0].instance.getType(node.node.children[0])
            let second_type = node.node.children[1].instance.getType(node.node.children[1])
            if (!["timedelta", "number"].includes(first_type) || !["timedelta", "number"].includes(second_type)){
                put_error = true
                alerts.push("Todos os filhos deste nó devem ter um retorno Numérico ou Período de Tempo.")
            }
            else if (first_type === "number" && second_type !== "number"){
                put_error = true
                alerts.push("Um Número só pode ser divido por um Número.")
            }
        }
        //Validate if parent is valid
        if (node.parentNode != null) {
            if(node.parentNode.on_error){
                put_error = true
                alerts.push("O nó superior está inválido.")
            }
        }
        //Validate if a default value and type
        if (node.node.properties.default_value == null){
            put_error = true 
            alerts.push("É necessário fornecer um valor padrão que será usado como resultado em caso de divisão por zero.")
        }
        else if((node.node.children || []).length === 2 &&
            node.node.properties.default_value_type !== this.getType(node.node)){
            put_error = true 
            const correct_type = this.getType(node.node)
            const default_value_type = node.node.properties.default_value_type
            const type_translate = {"number":"Número", "timedelta":"Perído de Tempo"}
            alerts.push(`O valor padrão deve ser um ${type_translate[correct_type]} mas é um ${type_translate[default_value_type]}.`)
        }
        return {validated: !put_error, alerts: alerts}
    }

    getType(node){
        if ((node.children || []).length ===0) return "void"
        let first_type = node.children[0].instance.getType(node.children[0])
        let second_type = node.children[1]?.instance.getType(node.children[1])
        if (first_type==="number")return "number"
        else if (first_type==="timedelta" && second_type==="timedelta") return "number"
        else if (first_type==="timedelta" && second_type==="number") return "timedelta"
        return "void"
    }
}
